import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  const initials = buyer.name.split(" ").map(p => p[0]).join("");
  return <div className="pointer-events-none fixed inset-x-3 bottom-24 z-50 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:w-80" aria-live="polite" data-id="element-39" data-mp="163mm322vbovk">
      <AnimatePresence data-id="element-40" data-mp="1fw241ze60dgg">
        {open && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-brand-100 bg-white p-3 pr-9 shadow-xl" data-id="element-41" data-mp="1fxn0xvnyc8hh">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-700 text-sm font-bold text-white" data-id="element-42" data-mp="s5ydasm2s86v">
              {initials}
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-43" data-mp="23lmzhhri936m">
              <p className="font-bold text-ink" data-id="element-44" data-mp="23l3ko9x5iuwt">
                {buyer.name} <span className="font-normal text-muted" data-id="element-45" data-mp="2anji9cw5y368">from {buyer.place}</span>
              </p>
              <p className="text-ink" data-id="element-46" data-mp="2fmmov1rskhgb">
                just purchased <span className="font-semibold text-brand-700" data-id="element-47" data-mp="2fpha2vimq6as">ECU Decision System™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-cta-dark" data-id="element-48" data-mp="2pltzvib20009">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-49" data-mp="2pjra8zdtc8w2" />
                Verified purchase · {buyer.ago}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:bg-brand-50 hover:text-ink" aria-label="Close notification" data-id="element-50" data-mp="1wy7vi7u04rcc">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="196j3ksl3e4vx" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}